import React, {useState} from "react";
import { Button, Form, Modal } from "react-bootstrap";

const GenericConfirmationModal = ({ showModal, handleClose, isShowReason, title, message, reasonOnChange, buttonText, handleConfirm, ...otherProps  }) => {
    const [reason, setReason] = useState("");

    const handleConfirmWithReason = async (event) => {
        event.preventDefault();
        await handleConfirm(reason); // Pass the reason along with other arguments
        setReason(""); // Clear the reason after confirming
    };

    return (
        <Modal show={showModal} onHide={handleClose} backdrop={"static"}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            {isShowReason && <Modal.Body>
                <p>{message}</p>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Reason?</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="e.g: reason for the change/action"
                        onChange={e => setReason(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body> }
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={async event => await handleConfirmWithReason(event)} type={'submit'}>
                    {buttonText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GenericConfirmationModal;
